import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button,
  InputNumber,
} from 'antd'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormCalcManagement = ({
  form, handleSubmit,
  detailDplkFee, isSubmit,
}) => {
  const { getFieldDecorator, validateFields } = form

  return (
    <Card>
      <Form
        {...formItemLayout}
        onSubmit={(e) => {
          e.preventDefault()
          validateFields((err, values) => {
            if (!err) {
              handleSubmit(values)
            }
          })
        }}
      >
        <Form.Item label="Persentase">
          {getFieldDecorator('fee_percentage', {
            initialValue: detailDplkFee.percentage,
            rules: [{ required: true }],
          })(
            <InputNumber
              min={0}
              max={100}
              formatter={value => `${value}%`}
              parser={value => value.replace('%', '')}
            />,
          )}
        </Form.Item>
        <Form.Item {...tailLayout} className="btn-primary-wrapper">
          <Button onClick={() => history.push('/calculator-management/biaya-dplk')} className="mr-2">Cancel</Button>
          <Button type="primary" htmlType="submit" loading={isSubmit}>Submit change</Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

FormCalcManagement.propTypes = {
  detailDplkFee: PropTypes.object,
  handleSubmit: PropTypes.func,
  form: PropTypes.any,
  /* loadStatus: PropTypes.bool, */
  isSubmit: PropTypes.bool,
}

export default Form.create({ name: 'calcManagementForm' })(FormCalcManagement)
